import React from "react";
import CancelAppointment from "./modals/CancelAppointment";
import Overlay from "./Overlay";
import {AppointmentSelectionModal} from "./modals/AppointmentSelectionModal";
import Banner from "../types/Banner";
import {ImageType} from "../types/Branding";
import SystemAPI from "../network/SystemAPI";

interface NavState{
    showLoading:boolean
    banner?:Banner
    logo:string
}
class Nav extends React.Component<{}, NavState>{

    constructor(props) {
        super(props);
        this.state = {
            showLoading:false,
            logo:""
        }
        this.getBannerElem = this.getBannerElem.bind(this);
    }

    componentDidMount() {
        this.setState({ showLoading: true }, () => {
            let currentURL = window.location.href;
            SystemAPI.getProductBrandingFromURL(currentURL).then(data => {
                let ProductID = data.ProductID;
                this.setState({logo:data.ProductLogoURL})

                SystemAPI.getBanner(ProductID).then(data => {
                    if (data.show) {
                        this.setState({ banner: data.banner, showLoading: false })
                    } else {
                        this.setState({ showLoading: false })
                    }
                })

            })
        })
    }

    getBannerElem() {
        if(!this.state.banner)
            return null;
        return (
            <div className="alert alert-danger m-0 d-print-none" role="alert">
                <p className="primary-black m-0">
                    {this.state.banner.Text}
                </p>
            </div>
        )
    }


    render(): React.ReactElement<any, string | React.JSXElementConstructor<any>> | string | number | {} | React.ReactNodeArray | React.ReactPortal | boolean | null | undefined {

        return (
            <React.Fragment>
                <AppointmentSelectionModal/>
                <Overlay show_loading={this.state.showLoading}/>
                <CancelAppointment/>

                <div className={"p-0 m-0 nav-wrapper"}>

                    <div className ="p-0 m-0 container-fluid">
                        {this.getBannerElem()}
                        <nav className="navbar navbar-expand-lg navbar-light ">

                            <a className="navbar-brand verlag-bold nav-href" href="/">
                              <span><img src={this.state.logo} width={'180px'}
                                        //  src={"https://storage.googleapis.com/streamline-bucket/FullNoBackground.png"}
                                        className="d-inline-block align-top nav-href pr-2" alt=""/></span>
                                {/*<span className={"navspan-text"}>Streamline</span>*/}
                            </a>

                            <button className="navbar-toggler" type="button" data-toggle="collapse"
                                    data-target="#navbarText"
                                    aria-controls="navbarText" aria-expanded="false" aria-label="Toggle navigation">
                                <span className="navbar-toggler-icon"></span>
                            </button>
                            <div className="collapse navbar-collapse float-right " id="navbarText">

                                <ul className="navbar-nav  immy-blue mr-auto immy-blue">
                                    <li className={"nav-item active "}>

                                        <a className="nav-link   immy-blue" href="/appointment" >
                                            Create Appointment
                                        </a>

                                    </li>

                                    <li className={"nav-item active "}>

                                        <a className="nav-link   immy-blue" href="#"  onClick={() =>  // @ts-ignore
                                            window.$("#" + CancelAppointment.ID).modal('show')}>
                                            Cancel Appointment
                                        </a>

                                    </li>

                                    <li className={"nav-item active"}>
                                        <a className="nav-link   immy-blue" href={"/results"}>
                                            Get Testing Results
                                        </a>
                                    </li>

                                    {/*  <li className={"nav-item active"}>
                                      <a className="nav-link   immy-blue" href={"/retrieve"}>
                                          Retrieve Confirmation Code
                                      </a>
                                  </li>*/}

                                </ul>
                            </div>
                        </nav>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default Nav;